import { gql } from '@apollo/client';

import FILES from '../fragments/documents/files';

export const UPDATE_FILES = gql`
  ${FILES}
  mutation updateManyFileEntity($updatedDoc: [FileInput!]!, $filter: [FileInput!]!) {
    updateManyFileEntity(updatedDoc: $updatedDoc, filter: $filter) {
      ...Files
    }
  }
`;

export const CREATE_FILES = gql`
  ${FILES}
  mutation createManyFileEntity($doc: [FileInput!]!) {
    createManyFileEntity(doc: $doc) {
      ...Files
    }
  }
`;

export const CREATE_FILE_SINGLE = gql`
  ${FILES}
  mutation CreateFile($doc: FileInput!) {
    createFileEntity(doc: $doc) {
      ...Files
    }
  }
`;

export const DELETE_FILES = gql`
  mutation deleteManyFileEntity($ids: [String!]!) {
    deleteManyFileEntity(ids: $ids) {
      message
    }
  }
`;

export const DELETE_FILE_SINGLE = gql`
  mutation DeleteFile($id: String!) {
    deleteFileEntity(id: $id) {
      affected
      message
    }
  }
`;
